import axios from "axios";
import { store } from "../../../../store/store";
import { getIP } from "../../../ui";
import { enviarLogDoctorNotifyEmision, enviarLogDoctorErrorNotifyEmision } from "./log/logIssue";

// Obtén el estado global de Redux
const reduxState = store.getState().company;
const urlServer = reduxState?.companyInstance?.urlServer;

// EMISION A FONASA
export const issueFonasa = (values, dataFonasa) => {
    axios.post(`${urlServer}/fonasa/emisionfonasa`, dataFonasa)
        .then((response) => {
            console.log(response)
            if (response.data.codigoRespuesta === 200) {
                getIP()
                    .then(responseIP => {
                        enviarLogDoctorNotifyEmision('[Medipass Fonasa] Response Notify Telemedicine', values.professionalDNI, values.professionalName ?? values.professionalNameComplete, values.patientDNI, values.patientName, values.patientLastName, response.data, responseIP.data);
                    })
            } else {
                getIP()
                    .then(responseIP => {
                        enviarLogDoctorErrorNotifyEmision('[Medipass Fonasa] Response Notify Telemedicine Failed', response.data, values.professionalDNI, values.professionalName ?? values.professionalNameComplete, values.patientDNI, values.patientName, values.patientLastName, responseIP.data, dataFonasa.folioInfo);
                    })
            }
        }).catch((error) => {
            console.log(error)
            getIP()
                .then(responseIP => {
                    enviarLogDoctorErrorNotifyEmision('[Medipass Fonasa] Response Notify Telemedicine Failed', error, values.professionalDNI, values.professionalName, values.patientDNI, values.patientName, values.patientLastName, responseIP.data, dataFonasa.folioInfo);
                })
        })
}
